import {Center} from "@chakra-ui/react";

const NoPage = () => {
    return <>
    <Center>
    <h5>404 Page not foud</h5>
    </Center>
    </>
};

export default NoPage;
